<template>
  <div>Redirecting...</div>
</template>
<script>
/* eslint-disable no-undef */

import { msalInstance, loginRedirect } from '../services/auth/auth.service'

export default {
  mounted() {
    window.Office.onReady(() => {
      msalInstance
        .handleRedirectPromise()
        .then((response) => {
          if (response) {
            Office.context.ui.messageParent(
              JSON.stringify({
                status: 'success',
                result: response,
              })
            )
          } else {
            // Otherwise, invoke login
            console.log('msalInstance.loginRedirect')
            loginRedirect()
          }
        })
        .catch((error) => {
          const errorData = `errorMessage: ${error.errorCode} message: ${error.errorMessage}errorCode: ${error.stack}`
          Office.context.ui.messageParent(
            JSON.stringify({ status: 'failure', result: errorData })
          )
        })
    })
  },
}
</script>
